webpackJsonp([61793728319066],{

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookRedux = __webpack_require__(38);
	
	var _LoreHookRedux2 = _interopRequireDefault(_LoreHookRedux);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookRedux2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'lore-hook-redux'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Source code for this hook can be found on GitHub ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/packages/lore-hook-redux' },
	        'at this link'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hooks is responsible for creating the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://redux.js.org/docs/basics/Store.html' },
	        'Redux Store'
	      ),
	      ' and applying any desired middleware.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Config'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Configuration file for Redux\n       *\n       * This file is where you define overrides for the default Redux behavior.\n       */\n\n      // import { compose, applyMiddleware, combineReducers, createStore } from \'redux\';\n      // import { thunk } from \'redux-thunk\';\n      // import { batchedSubscribe } from \'redux-batched-subscribe\';\n      // import _ from \'lodash\';\n\n      export default {\n\n        /**\n         * Middleware injected into the dispatch flow, placed at the point between\n         * dispatching an action, and the moment it reaches the reducer.\n         *\n         * http://redux.js.org/docs/advanced/Middleware.html\n         */\n\n        // middleware: [thunk],\n\n        /**\n         * Length of time (in milliseconds) that needs to exist between updates\n         * to the Redux store before React is notified the store has changed.\n         * A value of zero corresponds to "one tick".\n         *\n         * https://lodash.com/docs/4.17.4#debounce\n         */\n\n        // debounceWait: 0,\n\n        /**\n         * Enhance the store with third-party capabilities such as middleware,\n         * time travel, persistence, etc.\n         *\n         * http://redux.js.org/docs/api/compose.html\n         *\n         * Note about the batchedSubscribe enhancer:\n         *\n         * When normalization is configured and enabled, action creators can end up\n         * firing multiple actions back-to-back. By default, these actions do not\n         * get batched by Redux (it notifies React that the store changed after every\n         * action), which means every action will cause React to re-render the application.\n         * When this occurs back-to-back over a very short period of time, the responsiveness\n         * (and usability) of the application can drop noticeably.\n         *\n         * The batchedSubscribe enhancer, combined with the use of the _.debounce function,\n         * is a way of preventing this behavior, by preventing Redux from notifying React\n         * about changes to the Store until at least X time has passed between updates.\n         *\n         * Lore sets this value to 0 by default, which translates to "one tick". This delay\n         * should be undetectable to users, but just long enough to make sure that all actions\n         * from a normalized response are processed before React is notified of the change.\n         */\n\n        // enhancer: function(middleware, config) {\n        //   return compose(\n        //     applyMiddleware.apply(null, middleware),\n        //     batchedSubscribe(_.debounce(function(notify) {\n        //       notify();\n        //     }, config.redux.debounceWait))\n        //   );\n        // },\n\n        /**\n         * Combine all reducers into a single reducer function, which will be used\n         * by the Redux store. If there are no reducers, returns an empty function\n         * to prevent Redux from throwing an error.\n         *\n         * http://redux.js.org/docs/api/combineReducers.html\n         */\n\n        // rootReducer: function(reducers) {\n        //   const hasReducers = Object.keys(reducers).length > 0;\n        //   return hasReducers ? combineReducers(reducers) : function() {};\n        // },\n\n        /**\n         * Initial state of the Redux store. Any data you specify here will\n         * be in the store when the application starts.\n         *\n         * http://redux.js.org/docs/api/createStore.html\n         */\n\n        // preloadedState: function() {\n        //   return {};\n        // },\n\n        /**\n         * Configure the Store used by the application\n         *\n         * http://redux.js.org/docs/api/createStore.html\n         */\n\n        // configureStore: function(rootReducer, preloadedState, enhancer) {\n        //   return createStore(rootReducer, preloadedState, enhancer);\n        // }\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-redux-index-js-f44a3accc4c55a768d91.js